module.exports = __webpack_public_path__ + "img/bg-top.f5e822fe.png";